import { createFileRoute } from '@tanstack/react-router';
import { FAQPage } from '@/features/faq/pages/faq-page';

export const Route = createFileRoute('/_public/faq')({
  component: FAQPage,
});
